import { Box, Button, Dialog, TextField, Typography } from '@mui/material';
import { type FC, useState } from 'react';

type AvaniMarkResolvedDialogProps = {
  toggle: boolean;
  onResolve: (comment: string | null) => void;
  onCancel: () => void;
  title?: string;
};

export const AvaniMarkResolvedDialog: FC<AvaniMarkResolvedDialogProps> = ({
  toggle,
  title = 'Resolve',
  onResolve,
  onCancel
}) => {
  const [comment, setComment] = useState<string | null>();

  const handleResolve = () => {
    onResolve(comment ?? '');
    setComment('');
    onCancel();
  };

  return (
    <Dialog open={toggle} closeAfterTransition={false} keepMounted>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          padding: 2
        }}
      >
        <Typography variant="h3">{title}</Typography>

        <Box
          sx={{
            flexGrow: 1,
            py: 3,
            [`& .MuiTextField-root`]: {
              width: '100%'
            }
          }}
        >
          {/* <Typography
            variant="body1"
            textAlign={'center'}
          >
            Comment
          </Typography> */}
          <TextField
            label={'Comment'}
            onChange={(e) => setComment(e.target.value)}
            multiline
            /* helperText={'Leave a comment'}
            sx={{
              padding: '16px',
              borderRadius: '16px',
              border: `1px solid ${theme.colors.alpha.black[30]}`
            }}*/
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button variant="outlined" color="secondary" onClick={onCancel} sx={{ mr: 1 }}>
            Cancel
          </Button>

          <Button color={'primary'} variant="contained" onClick={handleResolve}>
            {title}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
